import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Cash' },
    { value: 2, label: 'EFTPOS' },
    { value: 3, label: 'Internet' },
    { value: 4, label: 'Online' },
    { value: 5, label: 'Credit Card' },
    { value: 6, label: 'Cheque' },
    { value: 7, label: 'Journal' },
    { value: 8, label: 'External' },
    { value: 9, label: 'Money Order' },
  ],
});
